import React from "react";

const Star = ({fill,w,h}) => {
 return (
<svg width={w} height={h} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.06114 10L8.05695 9.99571L5.79983 6.65809L2.99833 9.91849L1.36097 8.78593L3.29983 5.97598L0 4.7619L0.464824 2.90862L3.8191 3.21321V0H5.85008V3.5607L9.03266 1.92192L10 3.61218L7.14824 5.07936L9.76968 8.96182L8.06114 10Z" fill={fill} />
</svg>
  )
};

export default Star;